import { ApolloClient, InMemoryCache } from '@apollo/client';

const windowLocation = typeof window !== 'undefined' ? window.location : undefined;

export const IS_TESTING_ENVIRONMENT =
  // running the code locally
  process.env.NODE_ENV === 'development' ||
  // test pages
  !!windowLocation?.hostname?.startsWith?.('oneaudi-feature-app') ||
  // query parameter
  new URLSearchParams(windowLocation?.search).get('environment') === 'development' ||
  // on qa.audiusa.com only use staging ENV
  windowLocation?.hostname.includes('qa');

export const ONEGRAPH_API_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://int.onegraph.audi.com/graphql'
  : 'https://onegraph.audi.com/graphql';

export const GRAPHQL_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://qa-api.audiusa.com/graphql'
  : 'https://api.audiusa.com/graphql';

export const IS_T3_WEBSITE = new URLSearchParams(windowLocation?.search).has('isdealer');
export const IS_MOCK = !!new URLSearchParams(windowLocation?.search).has('mock');

export const OADD_DEALERS_JSON =
  'https://fa-vlp-list-page.cdn.prod.collab.apps.one.audi/t3dealers.json';

export const apolloClient = new ApolloClient({
  uri: GRAPHQL_GATEWAY_URL,
  cache: new InMemoryCache(),
});
